﻿import Track from "@arcgis/core/widgets/Track";

export default class TrackWidgetWrapper {
    track: Track;

    constructor(track) {
        this.track = track;
    }

    isTracking(): boolean {
        return this.track.tracking;
    }

    start() {
        this.track.start();
    }

    stop() {
        this.track.stop();
    }
}
